import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { MatMenuModule } from '@angular/material/menu';
import { MatButton } from '@angular/material/button';
import type { RowActionConfig } from '../../data/table-column-config';
import { MatIcon } from '@angular/material/icon';
import { ResolveTranslateAbleTextPipe } from '@pct-ng/i18n';
import { isNil } from '@pct-ts/typeguard';
import { CustomMatSvgIconDirective } from '@pct-ng/icon';

type MenuItem<T> = {
  show: boolean;
  disabled: boolean;
  label: RowActionConfig<T>['label'];
  action: RowActionConfig<T>['action'];
};

@Component({
  selector: 'pct-feature-table-material-settings-cell',
  imports: [
    MatButton,
    MatIcon,
    MatMenuModule,
    ResolveTranslateAbleTextPipe,
    CustomMatSvgIconDirective,
  ],
  templateUrl: './settings-cell.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SettingsCellComponent<T> {
  readonly config = input.required<RowActionConfig<T>[]>();
  readonly rowItem = input.required<T>();
  readonly disabled = input(false);
  readonly index = input.required<string>();
  readonly tableId = input<string>();

  readonly menuItems = computed<MenuItem<T>[]>(() => {
    const rowItem = this.rowItem();
    return this.config().map((config: RowActionConfig<T>) => {
      const show = isNil(config.shouldShow) || config.shouldShow(rowItem);
      const disabled = show && !isNil(config.isDisabled) && config.isDisabled(rowItem);
      return {
        show,
        disabled,
        label: config.label,
        action: config.action,
      };
    });
  });
}
